'use client';

import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { ShoppingCart } from 'lucide-react';
import { motion } from 'framer-motion';
import { useStore } from '../context/StoreContext';

export function FloatingCartButton() {
  const { cart: cartItems, setCartOpen } = useStore();
  const [mounted, setMounted] = useState(false);

  useEffect(() => { setMounted(true); }, []);

  if (!mounted) return null;

  return createPortal(
    <motion.button
      aria-label="Open cart"
      onClick={() => setCartOpen(true)}
      className="fixed bottom-6 right-6 z-40 flex items-center justify-center w-14 h-14 bg-hprimary text-white rounded-full shadow-lg hover:bg-hprimary-700 transition-colors"
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
    >
      <ShoppingCart className="w-6 h-6" />
      {cartItems.length > 0 && (
        <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
          {cartItems.length}
        </span>
      )}
    </motion.button>,
    document.body
  );
}
